<template>
  <div class="home" style="height:100%">
    <a-layout id="components-layout-demo-fixed-sider" >
      <a-layout-sider :style="{width:width,minWidth: 'inherit',maxWidth: '216px',flex: '0 0 216px',overflow: 'hidden', height: '100%', position: 'fixed', left: 0,top:0,zIndex:20}" v-model="collapsed" :trigger="null" collapsible>
        <div class="logo" style="height:64px;box-sizing:border-box;padding-left:24px">
          <img style="width: 42px;height: auto;" src="../../static/logo1.png" alt="">
          <div style="display:inline-block;">
            <img style="width: 92px;height: auto;" src="../../static/logo-text.png" alt="">
          </div>
        </div>
          <a-menu
            :openKeys="openKeys"
            mode="inline"
            @openChange="onOpenChange" 
            :defaultSelectedKeys="defaultSelectedKeys"
            :inline-collapsed="collapsed"
          >


        <a-menu-item key="1" class="single" >
          <router-link :style="{padding:pleft}" to="/main">
            <span><a-icon type="home" /><span>首页</span> </span>
          </router-link>
        </a-menu-item>



        <a-sub-menu key="sub1">
          <span slot="title"><a-icon type="idcard" /><span>客资管理</span></span>
          <a-menu-item key="5">
            <router-link to="/clue">
              线索
            </router-link>
          </a-menu-item>
          <a-menu-item key="3">
            <router-link to="/custom" >
              客户
            </router-link>
          </a-menu-item>
          <a-menu-item key="6">
            <router-link to="/business" >
              商机
            </router-link>
          </a-menu-item>
           <a-menu-item key="7">
            <router-link to="/clueseas">
              线索公海
            </router-link>
          </a-menu-item>
          <a-menu-item key="8">
            <router-link to="/customseas" >
              客户公海
            </router-link>
          </a-menu-item>
        </a-sub-menu>

        <a-sub-menu key="sub2">
          <span slot="title"><a-icon type="appstore" /><span>拓客利器</span></span>
          <a-menu-item key="9">
            <router-link to="/visitor" >
            精准获客
            </router-link>
          </a-menu-item>
          <a-menu-item key="10">
            <router-link to="/searvistor" >
            快商宝
            </router-link>
          </a-menu-item>
           <a-menu-item key="19">
            <router-link to="/receivelist" >
            领取列表
            </router-link>
          </a-menu-item>
          <a-menu-item key="11">
            <router-link to="/customizeclue" >
            定制线索包
            </router-link>
          </a-menu-item>
        </a-sub-menu>

        <a-sub-menu key="sub3">
          <span slot="title"><a-icon type="appstore" /><span>销售工具</span></span>
          <a-menu-item key="12">
            <router-link to="/record" >
            呼叫中心
            </router-link>
          </a-menu-item>
          <!-- <a-menu-item key="13">
            <router-link to="/shortmessage" >
            短信
            </router-link>
          </a-menu-item>
          <a-menu-item key="14">
            <router-link to="/" >
            销售目标
            </router-link>
          </a-menu-item>
          <a-menu-item key="15">
            <router-link to="/" >
            代办计划
            </router-link>
          </a-menu-item> -->
        </a-sub-menu>

        <a-menu-item class="single" key="3">
          <router-link :style="{padding:pleft}" to="/wxshare" >
            <a-icon type="pie-chart" />
            <span>微信分享</span>
          </router-link>
        </a-menu-item>
      

        <a-sub-menu key="sub4">
          <span slot="title"><a-icon type="mail" /><span>数据中心</span></span>
           <a-menu-item key="16">
            <router-link to="/report">
              仪表盘
            </router-link>
          </a-menu-item>
          <a-menu-item key="17">
            <router-link to="/calltj" >
              呼叫统计
            </router-link>
          </a-menu-item>
          <a-menu-item key="30">
            <router-link to="/consume" >
              消费统计
            </router-link>
          </a-menu-item>
          <!-- <a-menu-item key="18">
            <router-link to="/detectStatic" >
              智呼助手统计
            </router-link>
          </a-menu-item> -->
          <a-menu-item key="19">
            <router-link to="/businesstj">
              业务统计
            </router-link>
          </a-menu-item>
          <a-menu-item key="20">
            <router-link to="/funnel" >
              销售漏斗
            </router-link>
          </a-menu-item>
          <a-menu-item key="21">
            <router-link to="/follow" >
              跟进统计
            </router-link>
          </a-menu-item>
          <!-- <a-menu-item key="22">
            <router-link to="/cardsta" >
              名片统计
            </router-link>
          </a-menu-item> -->
          <!-- <a-menu-item key="23">
            <router-link to="/achievement" >
              目标完成度
            </router-link>
          </a-menu-item> -->
        </a-sub-menu>

        <a-menu-item class="single" key="2">
          <router-link :style="{padding:pleft}" to="/market" >
            <a-icon type="pie-chart" />
            <span>应用市场</span>
          </router-link>
        </a-menu-item>
      </a-menu>
      <div class="main-sider-menu">
        <a target="_blank" href="/admin/main" >
          <a-icon type="setting" theme="filled"/>
          <span>管理后台</span>
        </a>
      </div>
      </a-layout-sider >
      <a-layout :style="{ paddingLeft: left1}">
        <a-layout-header class="header" :style="{ width:'100%',zIndex:9, paddingLeft: left2,background:'#fff', position: 'fixed', right: 0,top:0 }">
          <div>
            <span>
              <a-icon
                class="trigger"
                :type="collapsed ? 'menu-unfold' : 'menu-fold'"
                @click="chang()"
                style="color:#999;font-size:18px"
              />
            </span>
            <a-input :style="{width:iwidth,transition: 'all 0.6s ease 0s'}" class="main-search" ref="userNameInput" @mouseover="over" @mouseout="out" v-model="search" :placeholder="ptext">
              <a-icon slot="prefix" type="search" />
            </a-input>
          </div>
      
          <div class="top-account-info">
            <div class="communicate-index" @click="call">
              <h2>打个电话，联系客户 </h2>
              <div class="tel-img">
                <img src="../../static/svg/tel.svg" alt="">
              </div>
            </div>

            <div class="sip" @click="showModal">
              <a-icon class="sipicon" type="mobile" theme="filled" />
              <span class="siptext">SIP电话</span>
            </div>

            <router-link  to="/home/message" style="padding:0 30px">
              <a-badge dot >
                <a-icon type="bell" theme="filled" style="color:#4f7afd;font-size: 16px;padding:0 4px"/>
              </a-badge>
            </router-link>

    

            <a-dropdown overlayClassName="top-account-menu">
              <a class="ant-dropdown-link" style="color:rgba(0,0,0,.65);">
                <img src="../../static/head.png" class="mian-head" alt="">
                {{info.name}} <a-icon type="down" />
              </a>
              <div slot="overlay">
                <div class="mian-user-head">
                    <img src="../../static/head.png" alt="">
                    <span>{{info.name}}</span>
                    <router-link to="/center" >
                      个人中心<a-icon type="right" />
                    </router-link>
                </div>
                <a-menu>
                  <!-- <a-divider /> -->
                  <a-menu-item>{{info.company_info.name}}</a-menu-item>
                  <a-divider />
                  <a-menu-item @click="logout">退出登录</a-menu-item>
                </a-menu>
              </div>
    
            </a-dropdown>

          </div>
          <!-- <div class="top-account-info">
            <router-link  to="/home/message" style="padding:0 30px">
              <a-badge dot >
                <a-icon type="bell" style="color: rgba(0,0,0,.65);font-size: 18px;padding:0 4px"/>
              </a-badge>
            </router-link>

            <a-dropdown>
              <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                <a-icon type="user" style="color: rgba(0,0,0,.65);font-size:16px;padding-left:12px"/>
                <span>{{userinfo.company}}</span>
              </a>

              <a-menu slot="overlay">
                <a-menu-item key="1">
                  <router-link to="/home/main" >
                  <a-icon type="home" />
                  进入官网
                  </router-link>
                </a-menu-item>
                <a-menu-item key="2">
                  <router-link to="/home/main" >
                  <a-icon type="cluster" />
                  进入WXCMS后台
                  </router-link>
                </a-menu-item>
                <a-menu-item key="3">
                  <router-link to="/home/inquiry" >
                    <a-icon type="home" />
                    我的询盘
                  </router-link>
                </a-menu-item>
                <a-menu-item key="4">
                  <router-link to="/home/account/base" >
                    <a-icon type="snippets" />
                    账户信息
                  </router-link>
                </a-menu-item>
                 <a-divider style="margin:6px 0"/>
                <a-menu-item key="5" class="login-out">
                  <router-link to="/" >
                    <a-icon type="logout" />  
                    退出登录
                  </router-link>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div> -->


        </a-layout-header>
        <a-layout-content
          :style="{ overflow: 'initial',paddingTop:'64px' }"
        >
        <a-locale-provider :locale="zh_CN">
          <router-view/>
        </a-locale-provider>
        </a-layout-content>

          <!-- <a-layout-footer :style="{ textAlign: 'center'}">
            云销客 ©2020 万橡科技
          </a-layout-footer> -->
      </a-layout>
    </a-layout>

    <!-- 拨打电话 -->
    <div class="communicate-body" v-if="callshow">
      <div>
        <div class="communicate-head">
          <a-dropdown>
            <a class="ant-dropdown-link" >
              <img src="../../static/svg/drop.svg" alt="">
              <span>五卡话机</span>
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-for="(item,i) in calltypelist" :key="i">{{item}}</a-menu-item>
            </a-menu>
          </a-dropdown>

          <a-dropdown>
            <div class="agent-status" style="width: 70px; margin-top: 1px;" >
              SIM卡 {{currentsim}}<a-icon type="down" />
            </div>
            <a-menu slot="overlay"  @click="switchsim">
              <a-menu-item v-for="(item,i) in simlist" :key="i+1" :disabled="item">
                SIM卡{{i+1}}
              </a-menu-item>
            </a-menu>
          </a-dropdown>

          <div class="communicate-close"  @click="closecall">
            <img src="../../static/svg/close.svg" alt="">
          </div>

        </div>
      </div>



      <div class="communicate-body-oper exp" v-if="show2" id="blockpage">
          <a-spin />
      </div>

      <div class="communicate-body-oper" >
        <div class="communicate-oper" id="success" v-if="show3">
          <div class="number-input">
            <img src="../../static/svg/call.svg" alt="">
            <a-input autocomplete="off" v-model="phone" placeholder="请输入电话号码" style="font-size: 18px;"></a-input>
          </div>

          <div class="communicate-key">
            <div class="keyboard-box" >
              <span class="keyboard-btn" @click='_handleKeyPress' data-num='1'>1</span>
              <span class="keyboard-btn" @click='_handleKeyPress' data-num='2'>2</span>
              <span class="keyboard-btn" @click='_handleKeyPress' data-num='3'>3</span>
              <span class="keyboard-btn" @click='_handleKeyPress' data-num='4'>4</span>
              <span class="keyboard-btn" @click='_handleKeyPress' data-num='5'>5</span>
              <span class="keyboard-btn" @click='_handleKeyPress' data-num='6'>6</span>
              <span class="keyboard-btn" @click='_handleKeyPress' data-num='7'>7</span>
              <span class="keyboard-btn" @click='_handleKeyPress' data-num='8'>8</span>
              <span class="keyboard-btn" @click='_handleKeyPress' data-num='9'>9</span>
              <span class="keyboard-btn" @click='_handleKeyPress' data-num='*'>*</span>
              <span class="keyboard-btn" @click='_handleKeyPress' data-num='0'>0</span>
              <span class="keyboard-btn" @click='_handleKeyPress' data-num='#'>#</span>
            </div>

            <div class="communicate-call-btn">
              <!-- <a-button type="primary">了解更多</a-button> -->
              <img style="cursor:point" src="../../static/svg/callbtn.svg"  @click="totel" alt="">
              <!-- <a-button class="callbtn" type="primary" @click="totel">拨打电话</a-button> -->
            </div>
          </div>
        </div>

        <div class="fail-communicate-oper" v-if="show1" id="fail">
            <img src="/static/svg/fail_work.svg" alt="">
            <h1>目前话机无法正常工作，检查后重试</h1>
            <div>
              <p>1、检测话机是否正常运作，如断电、死机</p>
              <p>2、检测话机与电脑的连接是否正常，建议重新插拔USB设备，更换USB接口或数据线</p>
            </div>
        </div>

        <div v-if="show5" class="load-communicate">
          <div class="divinputforcall-uncall">
              <img style="width: 16px; height: 16px;" src="../../static/svg/down.svg"  @click="totel" alt="">
              <a-input style="font-size:18px" placeholder="请输入电话号码" autocomplete="off"></a-input>
              <img style="box-shadow: rgba(98, 205, 105, 0.6) 0px 0px 10px;border-radius: 50%;" src="../../static/svg/tel2.svg"  @click="totel" alt="">
          </div>

          <div class="communicate-record">
            <h3 class="result-title">该号码匹配到多个对象：</h3>
            <span class="group-title">联系人</span>
            <div v-for="(item,i) in xglist2" :key="i" class="group-info" @click="gjcontact(item.id)">
              <span>{{item.contact_name}}</span>
              <span>{{item.contact_name}}商机</span>
            </div>

            <span v-if="xglist" class="group-title">线索</span>
            <div v-if="xglist" class="group-info" @click="gjclue(xglist.id)" >
              <span>{{xglist.clue_name}}</span>
              <span>--</span>
            </div>
          </div>
                  
        </div>

        <div v-if="show6" class="load-communicate">
           <div class="divinputforcall-uncall">
                <img style="width: 16px; height: 16px;" src="../../static/svg/down.svg"  @click="totel" alt="">
                <a-input style="font-size:18px" placeholder="请输入电话号码" autocomplete="off"></a-input>
                <img style="box-shadow: rgba(98, 205, 105, 0.6) 0px 0px 10px;border-radius: 50%;" src="../../static/svg/tel2.svg"  @click="totel" alt="">
            </div>

          <div class="communicateaddclue">
            <div class="addclue-info">
              {{phone}} 未匹配到客户
            </div>
            <div class="addclue-btn-group">
              <a-button @click="addcustom(phone)" type="primary" size="small">创建客户</a-button>
              <a-button @click="addbusiness" type="primary" size="small">创建商机</a-button>
              <a-button @click="addclue(phone)" type="primary" size="small">创建线索</a-button>
            </div>
          </div>
        </div>

        <div v-if="show4" class="load-communicate">

            <div class="divinputforcall-uncall">
                <img style="width: 16px; height: 16px;" src="../../static/svg/down.svg"  @click="totel" alt="">
                <a-input style="font-size:18px" placeholder="请输入电话号码" autocomplete="off"></a-input>
                <img style="box-shadow: rgba(98, 205, 105, 0.6) 0px 0px 10px;border-radius: 50%;" src="../../static/svg/tel2.svg"  @click="totel" alt="">
            </div>


            <!-- 线索跟进 -->
            <div class="communicate-record">
                <div @click="headback" class="head-back">
                  <a-icon type="left" />返回匹配列表
                </div>
                <div class="head-top">
                    <span>{{cluedetail.clue_name}}</span>
                    <div class="labelContainer">
                        <div v-if="cluedetail.tag.length>0">--</div>
                        <div v-else class="type-list"><span v-for="(item,idx) in cluedetail.tag" :key="idx">{{item}}</span></div>
                       
                    </div>
                      
                    <a-dropdown :trigger="['click']" v-model="typevisible">
                        <span class="ant-dropdown-link add-type">
                            + 标签
                        </span>
                        <div slot="overlay" class="tags-panel">
                            <div class="tags-panel-title">设置标签</div>
                             <a-checkbox-group
                            v-model="value"
                            name="checkboxgroup"
                            :options="plainOptions"
                            @change="onChangetype"
                            />

                            <div class="btnContent">
                                <a-button size="small" click="handleMenuClick">取消</a-button>
                                <a-button size="small" @click="settag" type="primary">确定</a-button>
                            </div>
                        </div> 
                    </a-dropdown>

                    <a-textarea v-model="gjcontent" placeholder="勤写跟进，多赢单，限定500个字" :rows="4" />
                    <a-button  class="savephone" @click="gjhandleOk">保存</a-button>
                    
                </div>
            </div>

        </div>

        <div v-if="show7" class="load-communicate">

            <div class="divinputforcall-uncall">
                <img style="width: 16px; height: 16px;" src="../../static/svg/down.svg"  @click="totel" alt="">
                <a-input style="font-size:18px" placeholder="请输入电话号码" autocomplete="off"></a-input>
                <img style="box-shadow: rgba(98, 205, 105, 0.6) 0px 0px 10px;border-radius: 50%;" src="../../static/svg/tel2.svg"  @click="totel" alt="">
            </div>

            <!-- 联系人跟进 -->
            <div class="communicate-record">
                <div @click="headback" class="head-back">
                  <a-icon type="left" />返回匹配列表
                </div>
                <div class="head-top">
                    <span>{{contactdetail.contact_name}}</span>

                    <a-textarea v-model="gjcontent" placeholder="勤写跟进，多赢单，限定500个字" :rows="4" />
                    <a-button  class="savephone" @click="chandleOk">保存</a-button>
                    
                </div>
            </div>
        </div>


      </div>

    </div>

    <!-- sip电话 -->
     <a-modal
      title="SIP电话"
      :visible="sipvisible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      :footer="null"
      width="420px"
    >
      <a-descriptions :column="line" :size="sipsize">
        <a-descriptions-item label="IP / 域名">
          <div class="sipcontent">{{sipinfo.sip_address}}</div>
        </a-descriptions-item>
        <a-descriptions-item label="坐席账号">
          <div class="sipcontent">{{sipinfo.code}}</div>
        </a-descriptions-item>
        <a-descriptions-item label="坐席密码">
          <div class="sipcontent">{{sipinfo.pass}}</div>
        </a-descriptions-item>
        <a-descriptions-item label="使用说明">
          <div class="sipcontent"><a target="_blank" href="https://yh178.13524.net/explain/">https://yh178.13524.net/explain/</a></div>
        </a-descriptions-item>
      </a-descriptions>

      <a-form :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
        <a-form-item label="二维码">
          <img style="width:50%" :src="codesrc" alt="">
        </a-form-item>
        <a-form-item label="扫码说明">
          <div class="sipcontent">
            <p>1.打开手机中linphone软件</p>
            <p>2.点击左上角菜单并点击助手</p>
            <p>3.点击获取远程配置后再点击二维码</p>
            <p>4.扫码成功后点击获取并应用</p>
            <p>5.点击菜单进入账号后输入密码即可</p>
          </div>
        </a-form-item>
      </a-form>

      
    </a-modal>
  </div>
</template>

<script>
import router from "@/router/index"
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');
export default {
  name: 'home',
  data() {
    return {
      line:1,
      sipvisible:false,
      confirmLoading: false,
      sipsize:'middle',
      collapsed: false,
      left1:'216px',
      left2:'240px',
      zh_CN,

      defaultSelectedKeys: [this.$route.path],
      openKeys: [''],

      menulist:"",
      userinfo:"",
      search:"",
      phone:"",
      callshow:false,
      width:'216px',
      pleft:'6px',
      iwidth:'102px',
      ptext:'搜客资',


      show1:false,
      show3:false,
      show2:false,
      show5:false,
      show4:false,
      show6:false,
      show7:false,
      info:"",

      xglist:"",
      xglist2:"",
      cluedetail:"",
      contactdetail:"",
      plainOptions:[],
      simlist:[],
      currentsim:"",
      calltypelist:"",

      sipinfo:{
        code:"",
        pass:"",
        sip_address:""
      },
      siptype:"",
      codesrc:""
    };
  },
  mounted(){
  
    // 获取拨打方式
      this.$axios.get("/api/getcalltype",{
        headers: {
            "appid": this.appSet.appid,
            "appkey": this.appSet.appkey,
            "token":localStorage.getItem('token'),
        },
      }).then((res)=>{
          if(res.data.code==200){
            this.calltypelist=res.data.data
          }else if(res.data.code==300){
              this.$message.error(res.data.msg);
              this.$router.push('/login');
            }else{
                this.$message.error(res.data.msg);
            }
      }),
    // SIM卡
    // wsinit()
    // setTimeout(() =>{
      
    // },5000);
    // var qkstatus=switchstatus()
    // if(qkstatus==1){
    //   this.$message.success("SIM"+nowsim+'切卡成功');
    // }
    

    console.log(this.simlist)
     // 标签列表
        this.$axios.get("/api/getdatatags",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
        }).then((res)=>{
            if(res.data.code==200){
                this.plainOptions=res.data.data
            }else if(res.data.code==300){
              this.$message.error(res.data.msg);
              this.$router.push('/login');
            }else{
                this.$message.error(res.data.msg);
            }
        }),

     this.$axios.get("/api/userinfo",{
            headers:{
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
              localStorage.setItem('userid', res.data.data.id);
              this.info=res.data.data
              // 获取sip信息
              this.$axios.get("/api/getsipinfo",{
                  headers: {
                      "appid": this.appSet.appid,
                      "appkey": this.appSet.appkey,
                      "token":localStorage.getItem('token'),
                  },
                  params:{
                    user_id:this.info.id
                  }
                }).then((res)=>{
                    if(res.data.code==200){
                      if(res.data.data!=null){
                        this.sipinfo=res.data.data
                      }
                    }else if(res.data.code==300){
                        this.$message.error(res.data.msg);
                        this.$router.push('/login');
                      }else{
                          this.$message.error(res.data.msg);
                      }
                })
            }else if(res.data.code==300){
              this.$message.error(res.data.msg);
              this.$router.push('/login');
            }else{
                this.$message.error(res.data.msg);
            }
        }),

        // 二维码

        this.$axios.get("/api/qcordimg",{
          headers:{
            "appid": this.appSet.appid,
            "appkey": this.appSet.appkey,
            "token":localStorage.getItem('token'),
          },
          params:{
            id:localStorage.getItem('userid')
          }
        }).then((res)=>{
          // if(res.data.code==200){
            this.codesrc=res.data
          // }
        })



    // this.$axios.get('/api/getLeftMenu',{
    //   headers:{
    //     "appid": this.appSet.appid,
    //     "appkey": this.appSet.appkey,
    //     "token":localStorage.getItem('token'),
    //   },
    // }).then((res)=> {
    //   if(res.data.code==200){
    //     this.menulist=res.data.data
    //   }
    // })

    // this.$axios.get('/api/getuserself',{
    //   headers:{
    //     "appid": this.appSet.appid,
    //     "appkey": this.appSet.appkey,
    //     "token":localStorage.getItem('token'),
    //   },
    // }).then((res)=> {
    //   if(res.data.code==200){
    //     this.userinfo=res.data.data
    //   }
    // })
  },
  methods:{
    // sip电话
    handleCancel(){
      this.sipvisible=false
      
    },
    showModal(){
      this.sipvisible=true
    },
    
    switchsim(e) {
      changesim(e.key)
      var qkstatus=switchstatus()
      if(qkstatus==1){
        this.currentsim=e.key
        this.$message.success("SIM"+e.key+'切卡成功');
      }else{
        this.$message.error("切卡失败")
      }
    },
    // 跟进
      gjhandleOk(){
        this.$axios.get("/api/addfollow",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
              content:this.gjcontent,
              data_id:this.gjclueid,
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.gjvisible=false
                this.$message.success(res.data.msg); 
            }else{
                this.$message.error(res.data.msg); 
            }
        })
      },
    chandleOk(){

    },

      // 设置标签
        handleMenuClick(){
            this.typevisible=false
        },
        onChangetype(checkedValues) {
            this.tags=checkedValues
        },
        settag(){
            this.$axios.get("/api/setdatatags",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    data_id:this.phoneid,
                    tag:this.tags
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg);
                    this.$axios.get("/api/getdatatags",{
                        headers: {
                            "appid": this.appSet.appid,
                            "appkey": this.appSet.appkey,
                            "token":localStorage.getItem('token'),
                        },
                    }).then((res)=>{
                        if(res.data.code==200){
                            this.plainOptions=res.data.data
                        }else{
                            this.$message.error(res.data.msg);
                        }
                    })
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },

    addcustom(phone){
      this.callshow=false
      this.$router.push({path: '/addcustom',query:{ phone:phone}});
    },
    addclue(phone){
      this.callshow=false
       this.$router.push({path: '/addclue',query:{ phone:phone}});
    },
    addbusiness(){
      this.callshow=false
      this.$router.push({path: '/addbusiness'});
    },
    // 跟进
    gjclue(value){
      this.show4=true
      this.show5=false
      this.show7=false,
      this.$axios.get("/api/getdatadetail",{
          headers: {
              "appid": this.appSet.appid,
              "appkey": this.appSet.appkey,
              "token":localStorage.getItem('token'),
          },
          params:{
              id:value,
          }
      }).then((res)=>{
          if(res.data.code==200){
              this.cluedetail=res.data.data.info
          }else{
              this.$message.error(res.data.msg);
          }
      })
    },
    gjcontact(value){
      this.show7=true
      this.show5=false
      this.show4=false
      this.$axios.get("/api/contactdetail",{
          headers: {
              "appid": this.appSet.appid,
              "appkey": this.appSet.appkey,
              "token":localStorage.getItem('token'),
          },
          params:{
              id:value,
          }
      }).then((res)=>{
          if(res.data.code==200){
              this.contactdetail=res.data.data.info
          }else{
              this.$message.error(res.data.msg);
          }
      })
    },
    headback(){
      this.show4=false
      this.show5=true
      this.show7=false
    },
    // 退出登录
    logout(){
      this.$router.push('/login');
      localStorage.removeItem('token');
    },
    over(){
      this.iwidth='305px'
      this.ptext='请输入标题、手机、电话等关键词'
    },
    out(){
      this.iwidth='102px'
      this.ptext='搜客资'
    },
    totel(){
      var phone=this.phone
      var type=this.siptype
      if(!phone.match(/^[1][3,4,5,6,7,8,9][0-9]{9}$/)){
        return "请输入正确的手机号";
      }else{
        if(type==1){
             this.$axios.get("/api/sipcall",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                  phone:this.phone,
                  calltype:5,
                  callsource:2
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.show6=true
                    this.show3=false
                    this.$message.success(res.data.msg);
                }else if(res.data.code==4558){
                  this.$message.error(res.data.msg);
                }else{
                  this.show3=false
                  this.show5=true
                  this.xglist=res.data.info
                  this.xglist2=res.data.contact_list
                    // this.$message.error(res.data.msg);
                }
            })
        }else if(type==2){
          zhihu(phone)
          this.$axios.get("/api/zhihuisdata",{
              headers: {
                  "appid": this.appSet.appid,
                  "appkey": this.appSet.appkey,
                  "token":localStorage.getItem('token'),
              },
              params:{
                  phone:this.phone,
              }
          }).then((res)=>{
              if(res.data.code==2){
                  this.show6=true
                  this.show3=false
              }else{
                  this.show3=false
                  this.show5=true
                  this.xglist=res.data.info
                  this.xglist2=res.data.contact_list
                  // this.$message.error(res.data.msg);
              }
          })
        }
      }
    },
    chang(){
      if(this.collapsed==false){
        this.collapsed=true
        this.left1='80px',
        this.left2='104px',
        this.width='80px'
        this.pleft='0px'
      }else{
        this.collapsed=false
        this.left1='216px',
        this.left2='240px',
        this.width='216px'
        this.pleft='6px'
      }
    },

    call(){
      this.$axios.get("/api/getsipinfo",{
        headers: {
            "appid": this.appSet.appid,
            "appkey": this.appSet.appkey,
            "token":localStorage.getItem('token'),
        },
        params:{
          user_id:this.info.id
        }
      }).then((res)=>{
        if(res.data.code==200){
          var type=res.data.data.call_methods
          this.siptype=type
          console.log("type="+type)
          if(type==2){
              var simStatus= simlist()
              var nowsim=currsim()  
              if(simStatus!=undefined){
                simStatus=simStatus.split(",")
              }

              for(var i in simStatus){
                if(simStatus[i]==0){
                  this.simlist[i]=true
                }else{
                  this.simlist[i]=false
                }
              } 
              console.log("nowsim="+simStatus)
              this.currentsim=nowsim

            this.callshow=!this.callshow
            var link=linktype()
            if(link==2){
                // alert(link)
              this.show1=true,
              this.show2=false,
              this.show3=false,
              this.show6=false,
              this.show5=false,
              this.show4=false,
              this.show7=false
            }else{
              this.show3=true,
              this.show2=false,
              this.show1=false,
              this.show6=false,
              this.show5=false,
              this.show4=false,
              this.show7=false
            }
          }else if(type==1){
            this.callshow=!this.callshow
            this.show3=true 
          }
        }
      })
    
    },
    closecall(){
      this.callshow=false
    },
    //处理按键
_handleKeyPress(e) {
     let num = e.target.dataset.num;
    this.phone=this.phone+num

  },

    onOpenChange(openKeys) { 
      if (openKeys.length !== 0) {  
        this.openKeys = [openKeys[1]]
      } else {
        this.openKeys = ['']
      }
    },
  }
};
</script>
<style>
.single a{line-height: 30px !important;}
.ant-menu-item-selected li.ant-menu-item>a {
    padding: 0 38px 0 14px !important;

}
li.ant-menu-item>a {line-height: 40px;height: 40px;}
.ant-menu-inline .ant-menu-item::after{
  display:none
}
.ant-menu-sub.ant-menu-inline>.ant-menu-item {
    padding-left: 18px!important;
}
.ant-menu-item-selected{
  background: transparent !important;
}
.ant-menu-item-selected>a, .ant-menu-item-selected>a:hover {
    color: #fff!important;
    background: #4f7afd;
    /* padding-left: 30px; */
    border-radius: 4px;
}
.single{padding-left: 18px !important;padding-right: 16px !important;}
.ant-menu-item a{padding-left: 6px;}
.ant-menu-submenu .ant-menu-item>a {
    padding-left: 30px;
}
.ant-menu-submenu .ant-menu-item>a:hover,menuitem>a:hover{
  color: #4f7afd;
}
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  height: 32px;
  background: #fff;
  margin: 16px;
}
</style>




// WEBPACK FOOTER //
// src/components/home.vue